import { z } from "zod";
export const memberSchema = z.object({
  idTypeId: z.string().min(1, "Selecciona el tipo"),
  identification: z.string().min(1, "Ingresa la identificación"),
  legalName: z.string().min(1, "Ingresa el nombre legal"),
  email: z.email("Ingresa un correo válido"),
  phone: z.string().optional(),
  cityId: z.string().optional(),
  purchaseDate: z.string().nullable().optional(),
  advisorId: z.string().nullable().optional(),
  preferredWorkshopId: z.string().nullable().optional(),
  inviteOnCreate: z.boolean(),
  reason: z.string().optional(),
});
export const memberChangeReasonSchema = memberSchema.extend({
  reason: z.string().trim().min(1, "Indica el motivo del cambio"),
});
export type MemberFormValues = z.infer<typeof memberSchema>;

// Mismo criterio que `CATALOG_ENTRY_FORM_FIELDS` (catalogSchemas.ts): la
// lista de claves que `MemberForm` realmente renderiza, para que
// `applyApiFieldErrors` sepa a qué campos puede asociar un rechazo de la API
// (`identification`/`email`, `IDENTIFICATION_DUPLICATE`/`EMAIL_DUPLICATE`) y
// cuáles caen al toast genérico.
export const MEMBER_FORM_FIELDS = Object.keys(
  memberSchema.shape,
) as readonly (keyof MemberFormValues)[];
